<template>
    <div id="s-menuSave">
        <b-row class="mainSpace" >
            <!--TITRE - VISIBLE SEULEMENT EN VERSION DESKTOP-->
            <b-col xs="12" sm="12" md="12" lg="12" xl="12" style="padding:0 0;">
                <div class="text-nowrap" 
                    :class="'text-nowrap d-flex justify-content-'+ HAlign "
                    style="overflow-x:auto;border:0px solid blue;"
                >
                
                    <div v-if="status==''" class="pl-2 d-inline-flex" style="border:0px solid blue;">
                        <div v-if="showOptions" class="d-flex align-items-center justify-content-center" style="padding:1px;border-radius:5px;border:1px solid #606266;">
                            <b-icon @click="alignLeft" icon="text-left" class="mx-0 cursorPoint icon" font-scale="1"></b-icon>
                            <b-icon @click="alignCenter" icon="text-center" class="mx-2 cursorPoint icon" font-scale="1"></b-icon>
                            <b-icon @click="alignRight" icon="text-right" class="mx-0 cursorPoint icon" font-scale="1"></b-icon>
                        </div>
                        <div class="d-flex align-items-center justify-content-center pl-1" style="border:0px solid #606266;">
                            <b-icon @click="toogle" v-if="!showOptions" icon="gear" class="mx-0 my-1 cursorPoint icon" font-scale="1"></b-icon>
                            <b-icon @click="toogle" v-if="showOptions" icon="x" class="mx-0 my-1 cursorPoint icon" font-scale="1" :variant="getTheme.danger"></b-icon>
                        </div>
                    </div>
                    <div class="pl-0">  
                        <div v-if="status=='-'" class="d-flex align-items-center justify-content-center">
                            <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                            <b-spinner type="grow" :variant="getTheme.danger"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                        </div>  
                        <div v-else-if="status=='1'" class="d-flex align-items-center justify-content-center">
                            <span class="txtSize px-4">{{$t('g_Ok')}}</span>
                        </div> 
                        <div v-else-if="status=='2'" class="d-flex align-items-center justify-content-center">
                            <span class="txtSize px-4">{{$t('g_Erreur')}}</span>
                        </div>  
                        <div v-else-if="status=='3'" class="d-flex align-items-center justify-content-center">
                            <b-button v-show="newBtn" class="mx-1 py-0" id="btnCancel" name="btnCancel" :variant="getTheme.success" @click="$emit('new')"><small>{{$t('g_Annuler')}}</small></b-button>                                
                            <b-button v-show="deleteBtn" class="mx-1 py-0" id="btnDeleteConfirm" name="btnDeleteConfirm" :variant="getTheme.danger" @click="$emit('delete')"><small>{{$t('g_Confirmer')}}</small></b-button>
                        </div>
                        <div v-else-if="status=='4'" class="d-flex align-items-center justify-content-center">
                            <b-spinner small type="grow" style="width: 1.2rem; height: 1.2rem;" :variant="getTheme.olight"></b-spinner>
                            <b-spinner small type="grow" style="width: 0.8rem; height: 0.8rem;" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" style="width: 0.5rem; height: 0.5rem;" :variant="getTheme.dark"></b-spinner>
                            <span class="txtLoad px-2"><small>{{$t('g_ChargementEnCours')}}</small></span>
                            <b-spinner small type="grow" style="width: 0.5rem; height: 0.5rem;" :variant="getTheme.dark"></b-spinner>
                            <b-spinner small type="grow" style="width: 0.8rem; height: 0.8rem;" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" style="width: 1.2rem; height: 1.2rem;" :variant="getTheme.olight"></b-spinner>
                        </div>
                        <div v-else-if="status=='5'" class="d-flex align-items-center justify-content-center" >
                            <b-spinner small type="grow" :variant="getTheme.light"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.dark"></b-spinner>
                            <span class="txtLoad px-2"><small>{{$t('g_Recherche')}}</small></span>
                            <b-spinner small type="grow" :variant="getTheme.dark"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.secondary"></b-spinner>
                            <b-spinner small type="grow" :variant="getTheme.light"></b-spinner>
                        </div> 
                        <div v-else-if="status=='6'" class="d-flex align-items-center justify-content-center">
                            <b-button  id="btnCancel" name="btnCancel" class="mx-1 py-0" :variant="getTheme.success" @click="$emit('new')"><small>{{$t('g_Annuler')}}</small></b-button>                                
                            <b-button  id="btnDeleteConfirm" name="btnDeleteConfirm" class="mx-1 py-0" :variant="getTheme.danger" @click="$emit('customEmit')"><small>{{$t('g_Confirmer')}}</small></b-button>
                        </div>  
                    </div>
                    <div v-if="status==''" v-show="newBtn" class="pl-2">
                        <!--NEW-->
                        <s-button 
                            style="padding: 0px"
                            v-show="newBtn" 
                            id="newBtn" 
                            name="newBtn" 
                            :size="size"
                            @click.native="$emit('new')"
                            text="g_Nouveau"
                            color="main">
                        </s-button>
                    </div>
                    <div v-if="status==''" v-show="saveBtn" class="pl-2">
                        <!--SAVE-->
                        <s-button 
                            style="padding: 0px"
                            v-show="saveBtn" 
                            id="saveBtn" 
                            name="saveBtn" 
                            :size="size"
                            @click.native="$emit('save')"
                            text="g_Enregistrer"
                            color="green"
                            :disabled="btnSaveDisabled">
                        </s-button>
                    </div>
                    <div v-if="status==''" v-show="deleteBtn" class="pl-2">
                        <!--DELETE-->
                        <s-button
                            style="padding: 0px" 
                            v-show="deleteBtn" 
                            id="btnDelete" 
                            name="btnDelete"
                            :size="size"
                            @click.native="msg='3'"
                            text="g_Supprimer"
                            color="red"
                            :disabled="!deleteBtn">
                        </s-button>
                    
                    </div>
                </div>
            </b-col>
            <!--FIN - TITRE - VISIBLE SEULEMENT EN VERSION DESKTOP-->
        </b-row>      
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import mobileNav from '../../../mixins/mobileNav.js'

export default{
    name: 's-menuSave',
    mixins:[mobileNav],
    components: {
        
    },
    props: {
        newBtn: Boolean,
        saveBtn: Boolean,
        deleteBtn: Boolean,
        printBtn: Boolean,
        btnSaveDisabled: Boolean,
        msg: String,
        applyBtn: Boolean,
        annulerBtn: Boolean,
        dupliquerBtn: Boolean,
        customBtn1: Boolean,
        customText1: String,
        customColor1: String,
        customEmit: String,
        msgType: String,
        msgText: String,
    },
    data() {
        return {
            size: 'sm',
            showOptions : false,
            HAlign : 'center',
        }
    },
    created(){

    },
    methods: {
        toogle() {
            this.showOptions = !this.showOptions
        },
        alignLeft() {
            this.HAlign = 'start'
        },
        alignCenter() {
            this.HAlign = 'center'
        },
        alignRight() {
            this.HAlign = 'end'
        }
    },
    computed: {
        ...mapGetters(['getTheme', 'getAllSize']),
        status() {
            return this.msg
        },
    }
}
</script>

<style lang="scss" scoped>

    .mainSpace{
        margin-left: 0px;
        margin-bottom: 0px;
        width: 100%;
    }
    .icon:hover {
        animation: zoom-in-zoom-out 1s ease infinite;
        color: blue;
    } 
    @keyframes zoom-in-zoom-out {
        0% { transform: scale(1, 1); }
        50% { transform: scale(1.5, 1.5); }
        100% { transform: scale(1, 1); }
    }
    @keyframes zoom-confirmation {
        0% { transform: scale(1, 1); }
        50% { transform: scale(0, 0); }
        100% { transform: scale(1, 1); }
    }
</style>